import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { useGetItemsPerRowResponsive } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { BrandSearchContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchContext";
import { ImprovedBrandSearch } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/ImprovedBrandSearch";
import { ButtonVariants } from "@faire/web--source/slate/Button";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { trackSearchProductCarouselBrandClick } from "@faire/web-api--source/events/search/click/productCarouselBrand";
import { IBrandSearchQueryUXMessaging } from "@faire/web-api--source/indigofair/data/IBrandSearchQueryUXMessaging";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { observer } from "mobx-react";
import React from "react";

export const BRAND_SEARCH_CAROUSEL_CONTAINER_NAME = "brand_search_carousel";

interface IProps {
  products: ILeanProductTile[] | undefined;
  brand: ILeanProductTile.IBrand | undefined;
  containerName: string | undefined;
  isLoading: boolean;
  insiderMessage?: IBrandSearchQueryUXMessaging;
  queryString?: string;
  ctaText?: string;
  requestId?: string;
  mobilePadding?: number;
  className?: string;
  buttonVariant?: ButtonVariants;
  isOnSearchPage?: boolean;
}

const BrandSearchBase: React.FC<IProps> = ({
  products,
  brand,
  containerName,
  isLoading,
  insiderMessage,
  queryString,
  requestId,
  ctaText,
}) => {
  const brandPagePath = brand?.token
    ? brandPage(brand.token, {
        page: 1,
        refS: queryString,
      })
    : "";

  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);
  const isLoggedInRetailer = useIsLoggedInRetailer();

  const itemsPerRowResponsive = useGetItemsPerRowResponsive(
    isSideBarVisible && isLoggedInRetailer
  );
  const productGridColumnCount = useResponsiveValue(itemsPerRowResponsive);

  const handleBrandClick = (identifier: string | undefined) => () => {
    if (identifier && requestId && brand?.token && containerName) {
      trackSearchProductCarouselBrandClick(
        `${containerName}|${identifier}`,
        requestId,
        brand.token
      );
    }
  };

  return (
    <BrandSearchContext.Provider
      value={{
        brand,
        brandPagePath,
        handleBrandClick,
        products,
        requestId,
        searchString: queryString,
        insiderMessage,
      }}
    >
      <ImprovedBrandSearch
        ctaText={ctaText}
        isLoading={isLoading}
        itemsPerRow={productGridColumnCount}
        products={products}
      />
    </BrandSearchContext.Provider>
  );
};

export const BrandSearch = observer(BrandSearchBase);
